// tslint:disable
export enum DiagnosisType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description ICD9
     */
    ICD9 = 1,
    /**
     * @description ICD10
     */
    ICD10 = 2,
    /**
     * @description DSM4
     */
    DSM4 = 3,
    /**
     * @description HCPCS LEVEL II Non-Orally Administered Medication & Chemotherapy Drugs (J-Codes)
     */
    JCODE = 4,
    /**
     * @description HCPCS LEVEL I Current Procedural Terminology (CPT) Code
     */
    CPTCode = 5,
    /**
     * @description HCPCS Modifier Codes for Procedure, Supply & DME (Durable Medical Equipment) Codes (Q-Codes)
     */
    QCODE = 6,
}
(DiagnosisType as any)['CPTCODE'] = 5;
